export default __webpack_public_path__ + "static/media/car2.a3541bc1.svg";